import React, { useMemo } from "react";

import User from "@mapmycustomers/shared/types/User";
import { convertLongLatToLatLngLiteral } from "@mapmycustomers/shared/util/geo/GeoService";

import MapTooltip from "@app/scene/map/components/MapTooltip";
import { userDisplayName } from "@app/util/formatters";

import { getUserLastLocationCoordinates } from "../../util/userLocationGeometryGetter";

interface Props {
  user: User;
}

const UserTooltip: React.FC<Props> = ({ user }) => {
  const position = useMemo(
    () => convertLongLatToLatLngLiteral(getUserLastLocationCoordinates(user)),
    [user]
  );
  return <MapTooltip position={position} showArrow={false} tooltip={userDisplayName(user)} />;
};

export default UserTooltip;
